import React from 'react'
import './AM9109.css'
import { Helmet } from "react-helmet";
import img1 from '../Components/Images/antennas/concealed.png'
import img2 from '../Components/Images/antennas/concealed1.png'

// import 'font-awesome/css/font-awesome.min.css';

function Concealed() {

  return (
    <div>
      <Helmet>
          <title>Best EAS concealed pedestal for all retail and industrial spaces</title>
          <meta name="description" content="Discover the best EAS antennas and merchandise security solutions for your retail store. Prevent theft with our advanced security systems." />
      </Helmet>
      <section className='row'>
      <div className="container py-5">
            <div className="row">
              {/* Left Side: Product Image */}
              <div className="col-md-6 text-center mt-5">
                {/* <img src={Img1} className="img-fluid rounded shadow" style={{height:"100vh"}} alt="EAS Anti-Theft System" /> */}
                <div style={{margin:"30px"}}>
                    <div>
                        <img src={img1} alt="" className='img-fluid w-50'/>
                    </div>
                </div>
              </div>     
              {/* Right Side: Product Details */}
              <div className="col-md-6 d-flex flex-column justify-content-center mb-5">
                <h2 className="fw-bold" style={{fontFamily:"sans-serif"}}>Floor Guard <br/>Concealed Systems</h2>
                <h4 className="text-primary text-center"></h4>
                <p className="mt-3">
                </p>
                <div className="p-2 max-w-2xl mx-auto">
                    <p>
                    Do you want unobscured access to your store, maintaining maximized visitor flow combined with solid merchandise protection? Our ARGUS AM Floor System offers ultimate discretion while performing its highly advanced security task.
                    The basic ARGUS AM Floor System consists of a wall mount control unit and an external antenna (2 transceiver coils), which is completely integrated in the floor of the store’s entrance.
                    </p>
                </div>
                <button className="btn btn-style btn-lg mt-3">Get a Quote</button>
              </div>
            </div>
            </div>
      </section>
      {/* icon display */}
      {/* <section className="row features">
        <div className="d-flex justify-content-center flex-wrap">
            <div className="icon-container mx-2 mx-md-3 my-2">
                <div className="icon-circle">
                    <i className="fas fa-shopping-cart"></i>
                </div>
                <p>Supermarket</p>
            </div>
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-tshirt"></i>
            </div>
            <p>Clothing Store</p>
            </div>
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-magic"></i>
            </div>
            <p>Cosmetic Store</p>
            </div>
    
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-glasses"></i>
            </div>
            <p>Optical Shop</p>
            </div>
            
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-baby"></i>
            </div>
            <p>Infant Store</p>
            </div>
            
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-female"></i>
            </div>
            <p>Boutiques</p>
            </div>
    
            <div className="icon-container mx-2 mx-md-3 my-2">
            <div className="icon-circle">
                <i className="fas fa-shoe-prints"></i>
            </div>
            <p>Shoe Store</p>
            </div>
            </div>
          </section> */}

   
    {/* what is more */}

    <section class="features1">
        <h2 class="title">What's more in Floor Guard concealed systems?</h2>
        <br/>
        <div class="feature-list1">
            <div class="feature-item1">
                <span class="icon">✔</span>
                <div class="feature-content1">
                    <h3>Invisible Security, Maximum Store Aesthetics</h3>
                    <p>Concealed installation ensures a seamless, clutter-free shopping environment, enhancing store aesthetics.
                    Improves space utilization, allowing for better store layout and customer flow.</p>
                </div>
            </div>
            <div class="feature-item1">
                <span class="icon">✔</span>
                <div class="feature-content1">
                    <h3>Powerful Detection with Minimal Interference</h3>
                    <p>Self-developed mainboard provides high sensitivity and strong anti-interference, ensuring accurate detection in busy retail environments.
                    Capable of detecting hard tags up to 2 meters for superior security coverage.</p>
                </div>
            </div>
            
            <div class="feature-item1">
                <span class="icon">✔</span>
                <div class="feature-content1">
                    <h3>Advanced Remote Debugging & Maintenance</h3>
                    <p>Remote monitoring allows for real-time tracking of system status.
                    Remote repair capabilities reduce downtime, eliminating the need for frequent on-site service visits.</p>
                </div>
            </div>
            <div class="feature-item1">
                <span class="icon">✔</span>
                <div class="feature-content1">
                    <h3>Versatile Installation for Various Flooring Types</h3>
                    <p>Designed for easy installation under multiple floor materials, making it ideal for a wide range of retail spaces.</p>
                </div>
            </div>
            
        </div>
    </section>
      
      
            {/* Technical Specifications */}
          <section className='row'>
          <div className="row mt-5 justify-content-center">
              <div className="col-10">
                <h3 className="fw-bold text-center">Technical Specifications</h3>
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th>Model No.</th>
                      <td>Floor Guard Concealed System</td>
                    </tr>
                    <tr>
                      <th>Material</th>
                      <td>PVC foam board</td>
                    </tr>
                    <tr>
                      <th>Frame Color</th>
                      <td>White</td>
                    </tr>
                    <tr>
                      <th>Frequency</th>
                      <td>58Khz</td>
                    </tr>
                    
                    <tr>
                      <th>Hard tag</th>
                      <td>1.2m-2.0m <sup>*</sup></td>
                    </tr>
                    <tr>
                      <th>Dimension</th>
                      <td>1600*600*20MM (Customized)</td>
                    </tr>
                    
                    
                    <tr>
                      <th>Operating Voltage</th>
                      <td>110-220v</td>
                    </tr>
                    <tr>
                      <th>Power Consumption</th>
                      <td>100w</td>
                    </tr>
                    <tr>
                      <th>Work Rate of Each Antenna</th>
                      <td>25w</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
              <div className='row col-10 mt-5'>
                <img src={img2}></img>                                     
              </div>
            </div>
          </section>
            
      
            {/* Customer Reviews */}
            <section className='row'>
            <div className="mt-5 mb-5 d-flex justify-content-center align-items-center">
              <div className="col-10">
                <h3 className="fw-bold text-center">Product Reviews</h3>
                <div className="border p-3 rounded shadow-sm">
                  <h5>John Doe</h5>
                  <p>⭐⭐⭐⭐⭐</p>
                  <p>Great security system! It helped reduce shoplifting incidents by 80% in our store.</p>
                </div>
              </div>
            </div>
            </section>
            
    
            
          </div>
  )
}

export default Concealed
